import { render } from "./Artboard_FeedCarrousel.vue?vue&type=template&id=2829120d&scoped=true"
import script from "./Artboard_FeedCarrousel.vue?vue&type=script&lang=js"
export * from "./Artboard_FeedCarrousel.vue?vue&type=script&lang=js"

import "./Artboard_FeedCarrousel.vue?vue&type=style&index=0&id=2829120d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2829120d"

export default script